import React, { useRef } from "react";
import { cls } from "@wss/cls";
import { connect } from "react-redux";
import { PlusLink } from "@clarkinc/zest-design-system/ui";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import AddToCart from "./Carousel/CarouselAddToCart";
import { CarouselItem } from "./Carousel/CarouselItem";
import CarouselPlatinumPlusExclusive from "./Carousel/CarouselPlatinumPlusExclusive";
import isNonExclusiveForPlatinumPlusProduct from "~/productListing/ProductBox/isNonExclusivePlatinumPlusProduct";
import { RootState, UserState } from "~/common/Store/models/RootReadonly";
import SaleBadgeAndPricing from "~/common/SaleBadgeAndPricing";
import StandardPrice from "./Pricing/StandardPrice";
import { useCtrImpressionTracking } from "~/analytics/ClickThroughRateTracking/useCtrImpressionTracking";
import { onClickCtrTrack } from "~/analytics/ClickThroughRateTracking/clickThroughRateHelpers";
interface Props {
  customersAlsoViewedItem: CarouselItem;
  user: UserState;
  originalLinkingItemNumber: string;
}
const CustomersAlsoViewedItemSection = ({
  customersAlsoViewedItem,
  user,
  originalLinkingItemNumber
}: Props) => {
  const {
    altText,
    description,
    imagePath,
    isWebstaurantPlusEligible,
    link,
    displaySalePrice,
    salePrice,
    price,
    unitOfMeasure,
    customerExclusivity,
    isRequestQuoteEnabled,
    itemNumber
  } = customersAlsoViewedItem;
  const caroueslRef = useRef<HTMLDivElement>(null);
  useCtrImpressionTracking(caroueslRef, {
    type: "CustomersAlsoViewed",
    source: originalLinkingItemNumber
  });
  return <div ref={caroueslRef} id="CustomersAlsoViewedSingleAnchor" className={cls("ag-mini", "ag-mini-cav", "box")} data-component="miniCustomersAlsoViewed" gtm-carousel-name="Mini Customers Also Viewed" data-sentry-component="CustomersAlsoViewedItemSection" data-sentry-source-file="CustomersAlsoViewedItemSection.tsx">
      <p className={cls("header-4", "ag-mini-header")}>Customers Also Viewed</p>
      {isRequestQuoteEnabled ? <div data-testid="raq-cav-single" className={cls("ag-item", "padded", "items-start")}>
          <div className={cls("product-image")}>
            <a href={link} title={altText} onClick={() => onClickCtrTrack("CustomersAlsoViewed", originalLinkingItemNumber, link)}>
              <NoScriptLazyImage alt={altText} src={imagePath} />
            </a>
          </div>
          <div className={cls("flex", "flex-col")}>
            <div>
              <a className={cls("description", "max-h-36")} href={link} onClick={() => onClickCtrTrack("CustomersAlsoViewed", originalLinkingItemNumber, link)}>
                {description}
              </a>
              <div className={cls("pricing")} data-component="Pricing">
                <p className={cls("price", "text-gray-800", "text-xs", "font-bold")}>
                  Contact for details
                </p>
              </div>
            </div>
            <div>
              <a href="/special-orders/" className={cls("btn", "btn-cart", "btn-small", "content-center")}>
                <span className={cls("inline-block", "max-w-28", "min-w-24")}>
                  Request a Quote
                </span>
              </a>
            </div>
          </div>
        </div> : <div className={cls("ag-item", "padded", "items-start")} gtm-tracking-number={itemNumber}>
          <div className={cls("product-image")}>
            <a href={link} title={altText} onClick={() => onClickCtrTrack("CustomersAlsoViewed", originalLinkingItemNumber, link)}>
              <NoScriptLazyImage alt={altText} src={imagePath} />
            </a>
          </div>
          <div>
            <a className={cls("description", "max-h-36")} href={link} onClick={() => onClickCtrTrack("CustomersAlsoViewed", originalLinkingItemNumber, link)}>
              {description}
            </a>
            {isWebstaurantPlusEligible && <PlusLink className="inline-flex pt-2.5" iconProps={{
          "data-testid": "plus-badge-icon-new"
        }} />}
            {displaySalePrice ? <SaleBadgeAndPricing salePricingClassNames={cls("p-0", "mb-0", "py-1", "flex", "items-center", "text-xs", "text-gray-800")} dataTestId="customer-also-viewed-sale" saleBadgeExtraClassNames={cls("px-1", "mr-1")} price={price} /> : null}
            <div className={cls("pricing", "mb-2")} data-component="Pricing">
              <StandardPrice price={displaySalePrice ? salePrice : price} unitOfMeasure={unitOfMeasure} showCreditKey={false} />
            </div>
            <CarouselPlatinumPlusExclusive user={user} customerExclusivity={customerExclusivity} />
            {isNonExclusiveForPlatinumPlusProduct(customerExclusivity, user) && <AddToCart useSingleItemStyle formId="relatedproduct_also-viewed_1" product={customersAlsoViewedItem} extraQuantityContainerClassName={cls("mt-2")} carouselName="MiniCustomerAlsoViewed" originalLinkingItemNumber={originalLinkingItemNumber} buttonClasses="py-0" />}
          </div>
        </div>}
    </div>;
};
export const mapStateToProps = (state: RootState) => ({
  user: state.user
});
export default connect(mapStateToProps)(CustomersAlsoViewedItemSection);